import i18next from 'i18next';

import { METRIC_TYPE } from '../../common/utils';

export const getMetricOptions = () => [
  {
    id: 'units',
    value: i18next.t('ANALYSIS.PERFORMANCE.PRODUCT_UNITS_SOLD'),
    type: METRIC_TYPE.INTEGER,
  },
  {
    id: 'turnoverExcludingTaxes',
    value: i18next.t('GENERAL.TURNOVER_EX_TAX'),
    type: METRIC_TYPE.CURRENCY,
  },
  {
    id: 'mix',
    value: i18next.t('ANALYSIS.PERFORMANCE.MIX'),
    type: METRIC_TYPE.PERCENTAGE,
  },
];
